export const get_api_url = (link, ignoredemail, isGo, absoluteUrl) => {
  let urlDomain = '';
  let mytChatUrl = '';

  switch (import.meta.env.VITE_APP_STAGE) {
    case 'production':
      urlDomain = 'https://gapi.myyogateacher.com';
      mytChatUrl = 'samvaad.azure-services.myyogateacher.com';
      break;
    default:
      urlDomain = 'https://gstg1.myyogateacher.com';
      mytChatUrl = 'samvaad-gstg1.myyogateacher.com';
      break;
  }

  if (link === 'mytChatUrl') {
    return mytChatUrl;
  }

  if (isGo || link.startsWith('/v2')) {
    if (import.meta.env.VITE_APP_GO_URL) {
      return `${import.meta.env.VITE_APP_GO_URL}${link}`;
    }

    return `${urlDomain}${link}`;
  }

  if (absoluteUrl) {
    return `${urlDomain}/${link}`;
  }

  return `${urlDomain}/cms/api/${link}`;
};

export const get_domain = () => {
  const { host } = window.location;
  const subdomain = host.split('.')[0];
  const urlDomain =
    subdomain === 'hridaya'
      ? 'https://myyogateacher.com'
      : 'https://student-testenv2.myyogateacher.com';

  return urlDomain;
};
